import { features } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          平台特色
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">丫丫漫画为你打造最好的在线阅读体验</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((item, idx) => {
            const iconColors = ['primary', 'accent', 'secondary', 'accent', 'primary'];
            const iconColor = iconColors[idx];
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70"
              >
                <div className={`w-10 h-10 md:w-11 md:h-11 rounded-lg flex items-center justify-center mb-3 ${
                  iconColor === 'primary' ? 'bg-primary-100' : iconColor === 'accent' ? 'bg-accent-100' : 'bg-secondary-100'
                }`}>
                  <i className={`${item.icon} text-lg md:text-xl ${
                    iconColor === 'primary' ? 'text-primary-600' : iconColor === 'accent' ? 'text-accent-600' : 'text-secondary-700'
                  }`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}